'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _ProgressBarComponent = require('../../components/common/ProgressBarComponent');

var _ProgressBarComponent2 = _interopRequireDefault(_ProgressBarComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigation: state.navigation
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_ProgressBarComponent2.default);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/common/ProgressBarContainer.jsx
// module id = 1685
// module chunks = 0